export default __webpack_public_path__ + "static/media/song2.f49d8c70.mp3";